import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M20.906 14.63a4.52 4.52 0 0 1 .738 3.603c-.155.695-.795 1.143-1.505 1.209a15.2 15.2 0 0 1-3.639-.105m4.406-4.707a4.52 4.52 0 0 0 .738-3.603c-.155-.695-.795-1.143-1.505-1.209a15.2 15.2 0 0 0-3.639.105m4.406 4.707H18M2.243 4.497v7.501m0 0v7.5m0-7.5h10.5m0-7.5v7.5m0 0V19.5"
    }, null, -1)
  ])))
}
export default { render: render }